export default "__VITE_ASSET__ODlRjV6r__"